import Vue from 'vue';
import Vuex from 'vuex';
import flatpickr from "flatpickr";


Vue.use(Vuex);

var store  = new Vuex.Store({
    modules: {
    },
});

window.axios = require('axios');

Vue.component('valuation-tool', require('./ValuationTool.vue').default);

const app = new Vue({
    el: '#valuationTool',
    data: {},
    mixins: [{
        methods: {
            flatpickr
        }
    }],
    store,
});